import React from "react";
import { valueIcon1 } from "../assets";
import { values } from "../constants";

const Values = () => {
  return (
    <div className="md:px-[100px] px-4 my-16">
      <h2 className="text-[#00A859] font-bold font-trajan md:text-3xl text-2xl mb-4 text-end">
      <span className="text-transparent stroke-green stroke-2 font-light">OUR</span> VALUES
      </h2>
      <div className="grid md:grid-cols-4 grid-cols-1">
        {
          values.map(item => (
            <div className="md:px-4 py-6">
              <img src={item.imageUrl} alt="" className="" />
              <h4 className="text-[#00A859] font-bold font-trajan text-lg my-4">
                {item.hText}
              </h4>
              <p className="text-[#B2B2B2] mb-6 font-barlow font-light">
                {item.pText}
              </p>
            </div>
          ))
        }
      </div>
    </div>
  );
};

export default Values;
